import { DOMAIN_TYPE_CLIENT_NOTIFICATION } from '../../../consts';
/**
 * @param state
 */
export var getClientNotification = function (state) {
    return function (notificationId) {
        return state.domain[DOMAIN_TYPE_CLIENT_NOTIFICATION]
            ? state.domain[DOMAIN_TYPE_CLIENT_NOTIFICATION][notificationId]
            : null;
    };
};
